import { cn, Tooltip, TooltipContent, TooltipTrigger } from "@tellescope/ui";
import { type LucideIcon } from "lucide-react";
import { type ReactNode } from "react";

export interface EventMetadataRowProps {
  icon: LucideIcon;
  hoverLabel?: string;
  children?: ReactNode;
  fadedText?: boolean;
}

export const EventMetadataRow = ({ icon: Icon, hoverLabel, children, fadedText }: EventMetadataRowProps) => {
  if (!children) {
    return null;
  }

  if (!hoverLabel) {
    return (
      <>
        <Icon size={16} className="text-muted-foreground mt-[1.5px]" />
        {typeof children === "string" ? (
          <p className={cn("text-sm leading-snug font-light", fadedText && "text-muted-foreground")}>{children}</p>
        ) : (
          children
        )}
      </>
    );
  }

  return (
    <>
      <Tooltip>
        <TooltipTrigger>
          <Icon size={16} className="text-muted-foreground mt-[1.5px]" />
        </TooltipTrigger>
        <TooltipContent side="left">{hoverLabel}</TooltipContent>
      </Tooltip>
      {typeof children === "string" ? (
        <p className={cn("text-sm leading-snug font-light", fadedText && "text-muted-foreground")}>{children}</p>
      ) : (
        children
      )}
    </>
  );
};
